import { useTranslations } from 'next-intl';
import { token } from '@/styled-system/tokens';
import {
  skeletonBar,
  skeletonBentoCell,
  skeletonBentoGrid,
  skeletonContainer,
  skeletonContentPadding,
  skeletonDesktopHeader,
  skeletonGalleryContainer,
  skeletonGalleryPadding,
  skeletonHeaderBarCenter,
  skeletonHeaderBarLeft,
  skeletonHeaderBarRight,
  skeletonMain,
  skeletonMobileCarousel,
} from './listingPageSkeleton.styles';

export const ListingPageSkeleton = () => {
  const t = useTranslations('hdp');
  return (
    <div className={skeletonContainer} aria-busy="true" aria-label={t('loadingPropertyDetails')}>
      <main className={skeletonMain}>
        {/* Desktop sticky header placeholder */}
        <div className={skeletonDesktopHeader}>
          <div className={skeletonHeaderBarLeft} />
          <div className={skeletonHeaderBarCenter} />
          <div className={skeletonHeaderBarRight} />
        </div>

        <div className={skeletonGalleryPadding}>
          <div className={skeletonGalleryContainer}>
            {/* Mobile: carousel placeholder */}
            <div className={skeletonMobileCarousel} />

            {/* Desktop: bento grid placeholder */}
            <div className={skeletonBentoGrid}>
              <div className={skeletonBentoCell} />
              <div className={skeletonBentoCell} />
              <div className={skeletonBentoCell} />
              <div className={skeletonBentoCell} />
            </div>
          </div>
        </div>

        <div className={skeletonContentPadding}>
          {/* eslint-disable-next-line hotpads/no-magic-numbers -- skeleton title bar uses an off-scale height from the loading design */}
          <div className={skeletonBar} style={{ width: '55%', height: '22px' }} />
          <div className={skeletonBar} style={{ width: '35%' }} />
          <div
            className={skeletonBar}
            style={{ width: '25%', height: token.var('sizes.500'), marginTop: token.var('spacing.default') }}
          />
          <div className={skeletonBar} style={{ width: '70%', marginTop: token.var('spacing.default') }} />
          <div className={skeletonBar} style={{ width: '60%' }} />
        </div>
      </main>
    </div>
  );
};
